export default __webpack_public_path__ + "static/media/paper1.00f2cc12.JPG";